import './App.scss'

import Router from 'router'
import Theme from './styles/theme-corretto'
import AuthProvider from 'common/auth/auth-provider'
import AuthModule from 'common/auth'
import { QueryClient, QueryClientProvider } from 'react-query'
import { AuthUserInterface } from 'common/auth/interfaces'
import { useEffect, useState } from 'react'
import Login from 'pages/login'
import { LoginActionEnum } from 'pages/login/interfaces'
import { ToastProvider } from 'common/services/toast/provider'
import GoogleAnalytics from 'common/utils/google-analytics'

declare global {
  interface Window {
    gtag?: (...args: any[]) => void
    dataLayer?: any[]
  }
}

export { GoogleAnalytics }

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
})

function App() {
  // TODO: Remover useStates, loading e useEffect quando colocar as permission no AWS
  const [auth, setAuth] = useState<AuthUserInterface | null>(null)
  const [loadPermissions, setLoadPermissions] = useState<boolean>(true)

  useEffect(() => {
    const getAuth = async () => {
      try {
        setLoadPermissions(true)
        const authData = await AuthModule.getAuthData()
        // Só atualiza o estado se houver dados de autenticação válidos
        if (authData && authData.jwt && authData.authData) {
          setAuth(authData)
        } else {
          // Se não há dados válidos, define como null mas só uma vez
          setAuth(null)
        }
      } catch (_) {
        // Em caso de erro, define como null mas só uma vez
        setAuth(null)
      } finally {
        setLoadPermissions(false)
      }
    }
    getAuth()

    if (GoogleAnalytics.isEnabled()) {
      console.log('Google Analytics inicializado em produção')
      GoogleAnalytics.trackEvent('app_initialized', {
        timestamp: new Date().toISOString()
      })
    }
  }, [])

  return (
    <ToastProvider>
      <QueryClientProvider client={queryClient}>
        {loadPermissions ? (
          <Login initialAction={LoginActionEnum.loadingPermisions} />
        ) : (
          <AuthProvider auth={auth}>
            <Theme>
              <Router />
            </Theme>
          </AuthProvider>
        )}
      </QueryClientProvider>
    </ToastProvider>
  )
}

export default App
